import { render } from "./RateConfigurationPage.vue?vue&type=template&id=7b073c30"
import script from "./RateConfigurationPage.vue?vue&type=script&lang=js"
export * from "./RateConfigurationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__